module.exports = __webpack_public_path__ + "img/dome-check-mark.c5192a4f.svg";